var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"box",staticClass:"vimeo-player relative"},[_c('vue-vimeo-player',{ref:"player",staticClass:"video-player",style:(_vm.videoDimensionsStyle),attrs:{"options":{
        background:false,
        autoplay:false,
        loop:true,
        byline:false,
        portrait:false,
        title:false,
        fullscreen:false},"videoId":_vm.value.vimeoId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }